const SoundbitesSortType = Object.freeze({
  RICHNESS: 'RICHNESS',
  TIME: 'TIME',
  AUTHOR_FOLLOWER: 'AuthorFollower',
  FOLLOWERS_VISITORS: 'FOLLOWERS_VISITORS'
})
export default SoundbitesSortType
export type SoundbitesSortTypeStrings = typeof SoundbitesSortType[keyof typeof SoundbitesSortType]
// RESERVE BELOW
